import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import ConnectIntegrationButton from "../../../common/button/connectintegrationbutton.component.jsx"
import { Intl } from "../../../state/helpers/IntlProps"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { ConfigurationSquare } from "../../../state/integration/IntegrationConfiguration"

type OwnProps = {
    integrationConfigurationId: string,
    configuration: ConfigurationSquare,
    intl: Intl,
}

const SquarePaymentsComponent = (props: OwnProps) => {
    if (!props.integrationConfigurationId) {

        const url = AppContext.getOptions().apiUrl + `/openid/connect/${INTEGRATION_KEY.SQUARE_PAYMENTS}/` +
            AppContext.getUserLoggedIn().id + `?r=/integrations/listing?open=${INTEGRATION_KEY.SQUARE_PAYMENTS}`

        return <div className="col-12 ui-module">
            <div className="form-group row">
                <label className="col-3 col-form-label text-align-right">
                    <FormattedMessage
                        id="integration.form.edit.connect"
                        defaultMessage="Connect"
                    />
                </label>
                <div className="col-9">
                    <ConnectIntegrationButton integrationKey={INTEGRATION_KEY.SQUARE_PAYMENTS} url={url} />
                </div>
            </div>
        </div>
    }


    return <div className="col-12 ui-module">
        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="accountId">
                <FormattedMessage
                    id="integration.form.edit.square.account_id"
                    defaultMessage="Account ID"
                />
            </label>
            <div className="col-9">
                <input
                    name="accountId"
                    value={props.configuration.accountId}
                    disabled={true}
                    id="accountId"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>
    </div>
}

export default injectIntl(SquarePaymentsComponent)


// WEBPACK FOOTER //
// ./src/integration/form/square/SquarePaymentsFormComponent.tsx